import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 回傳值
 */
export interface UserAuthViewDataResp extends GeneralResp {
    ssn: string;
    countryList: Array<CountryData>;
}

/**
 * @todo 國別
 */
export interface CountryData {
    countrycode: string;
    countrytitle: string;
}

/**
 * @todo 基本身份驗證 ViewData
 */
const GetUserAuthViewData = (): Promise<UserAuthViewDataResp> => {
    const url = RouteUrlList.API_UserAuthViewData.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.true,
            skipIdletimeout: ApiClient.paramTypeEnum.true,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<UserAuthViewDataResp>) => {
        return res.data;
    });
};

export default GetUserAuthViewData;
